import { useContext } from 'react';
import { AdvertDetailContext, AdvertDetailContextType } from '#advertDetail/contexts';

const useAdvertDetailContext = () => useContext<AdvertDetailContextType>(AdvertDetailContext);

export { useAdvertDetailContext };
